import { Box } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Alert from '@material-ui/lab/Alert';
import { useOktaAuth } from '@okta/okta-react';
import useAxios from 'axios-hooks';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { GET_OKTA_LOGIN } from '../../constants/api';
import { StyledAPIRequestHandler } from './APIRequestHandler.styled';

const getErrorMessage = (error) => {
  if (error?.response?.data?.detail) {
    return `Error - ${error.response.status}: ${error.response.data.detail}`;
  }
  return `Oops!  Something went wrong - ${error?.message}.`;
};

const APIRequestHandler = ({ loading, error, children }) => {
  const { oktaAuth } = useOktaAuth();

  const [{ data: redirectLoginUrl, loading: redirectLoginUrlLoading, error: redirectLoginUrlError }] = useAxios({
    method: 'get',
    url: `${GET_OKTA_LOGIN}`,
  });

  if (loading)
    return (
      <Box py={2}>
        <CircularProgress color="inherit" size={20} />
      </Box>
    );
  if (!_.isNil(error)) {
    console.info(redirectLoginUrlLoading);
    if (error.message && error.message.toLowerCase().includes('Network Error'.toLowerCase())) {
      if (!redirectLoginUrlLoading && _.isNil(redirectLoginUrlError)) {
        oktaAuth.tokenManager.clear();
        window.location.href = redirectLoginUrl.loginUrl;
      } else {
        return (
          <Box py={2}>
            <Alert severity="error">{getErrorMessage(error)}</Alert>
          </Box>
        );
      }
    } else {
      return (
        <Box py={2}>
          <Alert severity="error">{getErrorMessage(error)}</Alert>
        </Box>
      );
    }
  } else {
    return (
      <StyledAPIRequestHandler>
        <>{children}</>
      </StyledAPIRequestHandler>
    );
  }
};

APIRequestHandler.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.string,
  emptyResponse: PropTypes.bool,
  children: PropTypes.node,
};

export default APIRequestHandler;
